import { InferRequestType, InferResponseType } from "hono/client";
import { client } from "../client";

export const BUDDIES_QUERY_KEY = ["buddies"] as const;
export const UPDATE_WEEKLY_GOAL_MUTATION_KEY = ["buddies", "goal"] as const;

export type BuddiesResponse = InferResponseType<
  typeof client.buddies.$get,
  200
>;

export type WeeklyGoal = BuddiesResponse["weeklyGoal"];
export type GoalIntensity = WeeklyGoal["calories"];
export type Matchup = BuddiesResponse["matchups"][number];

export type Buddy = {
  id: string;
  firstName: string;
  lastName: string;
  avatarUrl: string | null;
  progress: number;
  goal: number;
  intensity: GoalIntensity;
};

export type UpdateWeeklyGoalRequest = InferRequestType<
  typeof client.buddies.goal.$patch
>["json"];

export type UpdateWeeklyGoalResponse = InferResponseType<
  typeof client.buddies.goal.$patch,
  200
>;
